import { globalModule } from '@/store/moduleName'

function breakSubErrors (subErrors) {
  let errorMessage = { chinMessage: '', portMessage: '' }
  if (typeof subErrors !== 'undefined' && subErrors) {
    subErrors.forEach(element => {
      errorMessage.chinMessage += element.chinMessage + '<br>'
      errorMessage.portMessage += element.portMessage + '<br>'
    })
  } else {
    errorMessage = { chinMessage: '系統繁忙!', portMessage: 'System busy!' }
  }
  return errorMessage
}

function httpStatusHandler (resp, vm) {
  if (resp.status === 201 || resp.status === 200) {
    vm.$store.dispatch(globalModule + '/setSnackbarMsg', vm.$t('eDocInternal.msg.saveSuccess'))
  }
}

export { breakSubErrors, httpStatusHandler }

export default { breakSubErrors, httpStatusHandler }
